import { AlignType } from 'common/types/styleTypes'
import { useCalculateFontSize } from './use-calculate-font-size'
import { useCalculateLineHeight } from './use-calculate-line-height'
import { useCalculateTextAlign } from './use-calculate-text-align'
import { useCalculateLetterSpacing } from './use-calculate-letter-spacing'
import { useCalculateFontFamily } from './use-calculate-font-family'
import { useCalculateFontStyle } from './use-calculate-font-style'
import { useCalculateFontWeight } from './use-calculate-font-weight'

export const useCalculateTypography = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontFamily,
  mobileFontFamily,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
} = {}) => {
  const returnUseCalculateFontFamily = useCalculateFontFamily({
    fontFamily,
    mobileFontFamily,
  })

  const returnUseCalculateFontStyle = useCalculateFontStyle({
    fontStyle,
    mobileFontStyle,
  })

  const returnUseCalculateFontWeight = useCalculateFontWeight({
    fontWeight,
    mobileFontWeight,
  })

  const returnUseCalculateFontSize = useCalculateFontSize({
    fontSize,
    mobileFontSize,
  })

  const returnUseCalculateLineHeight = useCalculateLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
  })

  const returnUseCalculateTextAlign = useCalculateTextAlign({
    textAlign,
    mobileTextAlign,
  })

  const returnUseCalculateLetterSpacing = useCalculateLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
  })

  return {
    ...returnUseCalculateFontSize,
    ...returnUseCalculateLineHeight,
    ...returnUseCalculateTextAlign,
    ...returnUseCalculateLetterSpacing,
    ...returnUseCalculateFontFamily,
    ...returnUseCalculateFontWeight,
    ...returnUseCalculateFontStyle,
  }
}
